import React, { useEffect, useRef, useState } from 'react';
import { supabase } from './supabase';
import 'leaflet/dist/leaflet.css';

const B = '#2563eb';

// Rejoue le trajet RÉELLEMENT enregistré (position_pings) pour UNE
// intervention — distinct de JourneyMap qui affiche les arrêts prévus du
// jour. Accès restreint côté RLS : directeur/responsable ou le technicien
// concerné pour son propre trajet uniquement (voir migration position_pings).
export default function TrajetReplay({ interventionId, clientNom, darkMode, onClose }) {
  const mapRef = useRef(null);
  const [pings, setPings] = useState(null); // null = chargement
  const [litige, setLitige] = useState(false);
  const [savingLitige, setSavingLitige] = useState(false);

  useEffect(() => {
    supabase.from('position_pings').select('*').eq('intervention_id', interventionId).order('recorded_at', { ascending: true })
      .then(({ data, error }) => {
        if (error) { console.error('Erreur trajet:', error); setPings([]); return; }
        setPings(data || []);
        if (data && data.length) setLitige(!!data[0].litige);
      });
  }, [interventionId]);

  useEffect(() => {
    if (!mapRef.current || !pings || pings.length === 0) return;
    let map;
    let cancelled = false;
    (async () => {
      const L = (await import('leaflet')).default;
      if (cancelled || !mapRef.current) return;
      map = L.map(mapRef.current);
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { attribution: '© OpenStreetMap', maxZoom: 19 }).addTo(map);

      const latlngs = pings.map(p => [p.lat, p.lng]);
      L.polyline(latlngs, { color: B, weight: 4, opacity: 0.85 }).addTo(map);

      const depart = latlngs[0], arrivee = latlngs[latlngs.length - 1];
      L.circleMarker(depart, { radius: 8, color: '#fff', weight: 2, fillColor: '#10b981', fillOpacity: 1 }).addTo(map).bindPopup('Départ');
      L.circleMarker(arrivee, { radius: 8, color: '#fff', weight: 2, fillColor: '#ef4444', fillOpacity: 1 }).addTo(map).bindPopup('Arrivée');

      map.fitBounds(L.latLngBounds(latlngs), { padding: [40, 40] });
    })();
    return () => { cancelled = true; if (map) map.remove(); };
  }, [pings]);

  const toggleLitige = async () => {
    setSavingLitige(true);
    const nouveau = !litige;
    const { error } = await supabase.from('position_pings').update({ litige: nouveau }).eq('intervention_id', interventionId);
    if (!error) setLitige(nouveau);
    else alert('Erreur: ' + error.message);
    setSavingLitige(false);
  };

  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(10,10,26,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 3000, padding: '20px' }}>
      <div onClick={e => e.stopPropagation()} style={{ width: '100%', maxWidth: '700px', maxHeight: '90vh', display: 'flex', flexDirection: 'column', background: darkMode ? '#1c1c1e' : '#fff', borderRadius: '20px', overflow: 'hidden', boxShadow: '0 24px 70px rgba(0,0,0,0.35)' }}>
        <div style={{ padding: '18px 22px', borderBottom: darkMode ? '1px solid #2c2c2e' : '1px solid #f0f0f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <p style={{ fontSize: '16px', fontWeight: 800, margin: 0 }}>🧭 Trajet réel — {clientNom || 'intervention'}</p>
            <p style={{ fontSize: '12px', color: '#9ca3af', margin: '2px 0 0' }}>{pings ? `${pings.length} point${pings.length > 1 ? 's' : ''} enregistré${pings.length > 1 ? 's' : ''}` : 'Chargement...'}</p>
          </div>
          <button onClick={onClose} style={{ border: 'none', background: 'none', fontSize: '22px', cursor: 'pointer', color: '#9ca3af' }}>×</button>
        </div>

        {pings && pings.length === 0 ? (
          <div style={{ padding: '50px 24px', textAlign: 'center' }}>
            <p style={{ fontSize: '13px', color: '#9ca3af' }}>Aucun trajet enregistré pour cette intervention (suivi non activé, ou données déjà purgées après 30 jours).</p>
          </div>
        ) : (
          <>
            <div ref={mapRef} style={{ height: '400px', background: '#eef2ff' }} />
            <div style={{ padding: '14px 22px', borderTop: darkMode ? '1px solid #2c2c2e' : '1px solid #f0f0f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
              <p style={{ fontSize: '12px', color: '#9ca3af', margin: 0, maxWidth: '360px' }}>Ce trajet est supprimé automatiquement après 30 jours, sauf s'il est marqué "litige" ci-dessous.</p>
              <button onClick={toggleLitige} disabled={savingLitige} style={{ padding: '9px 18px', borderRadius: '980px', border: 'none', background: litige ? '#ef4444' : (darkMode ? '#2c2c2e' : '#f3f4f6'), color: litige ? '#fff' : '#374151', cursor: 'pointer', fontWeight: 700, fontSize: '13px', whiteSpace: 'nowrap' }}>
                {litige ? '🔒 Conservé (litige) — retirer' : '⚠️ Marquer pour litige (conserver)'}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
